import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵinject, Optional, SecurityContext, ɵɵdirectiveInject, ɵɵdefinePipe, Pipe, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, SkipSelf } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalService } from '@akeela/local-storage';
import { __decorate, __param, __metadata } from 'tslib';

const lang = {
    "welcome": "Bienvenido a akeela i18n !!",
};

const lang$1 = {
    "welcome": "Welcome to akeelah i18n !!",
};

class I18nService {
    constructor() {
        this.languages = {};
        this.lang_default = 'es';
        this.langDefault = 'es';
        this.lang = this.langDefault;
        this.generateLang();
    }
    add(lang, lang_id) {
        if (isNullOrUndefined(this.languages[lang_id]))
            this.languages[lang_id] = {};
        this.languages[lang_id] = Object.assign(this.languages[lang_id], lang);
    }
    generateLang() {
        this.add(lang, 'es');
        this.add(lang$1, 'en');
    }
    set langDefault(lang_default) {
        this.lang_default = lang_default;
    }
    get langDefault() {
        return this.lang_default;
    }
    set lang(lang) {
        this.current_lang = lang;
    }
    get lang() {
        return this.current_lang;
    }
    getLangJson(langId) {
        if (isNullOrUndefined(this.languages[langId]))
            langId = this.langDefault;
        return this.languages[langId];
    }
}
/** @nocollapse */ I18nService.ɵfac = function I18nService_Factory(t) { return new (t || I18nService)(); };
/** @nocollapse */ I18nService.ɵprov = ɵɵdefineInjectable({ token: I18nService, factory: I18nService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(I18nService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AkeelaConfig {
}

class AkeelaConfigConst {
}
AkeelaConfigConst.constants = {};
AkeelaConfigConst.tagOpen = '{{';
AkeelaConfigConst.tagClose = '}}';

class AkeelaConfigService {
    constructor(config) {
        this.akeelaWorkflowConfig = new AkeelaConfig();
        if (config) {
            this.options = config;
        }
    }
    set options(opt) {
        this.akeelaWorkflowConfig.constants = (opt && opt.constants) ? opt.constants : AkeelaConfigConst.constants;
        this.akeelaWorkflowConfig.tagOpen = (opt && opt.tagOpen) ? opt.tagOpen : AkeelaConfigConst.tagOpen;
        this.akeelaWorkflowConfig.tagClose = (opt && opt.tagClose) ? opt.tagClose : AkeelaConfigConst.tagClose;
    }
    get constants() {
        return this.akeelaWorkflowConfig.constants;
    }
    get tagOpen() {
        return this.akeelaWorkflowConfig.tagOpen;
    }
    get tagClose() {
        return this.akeelaWorkflowConfig.tagClose;
    }
}
/** @nocollapse */ AkeelaConfigService.ɵfac = function AkeelaConfigService_Factory(t) { return new (t || AkeelaConfigService)(ɵɵinject(AkeelaConfig, 8)); };
/** @nocollapse */ AkeelaConfigService.ɵprov = ɵɵdefineInjectable({ token: AkeelaConfigService, factory: AkeelaConfigService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaConfigService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

class I18nPipe {
    constructor(sanitizer, i18n, config, localStorage) {
        this.sanitizer = sanitizer;
        this.i18n = i18n;
        this.config = config;
        this.localStorage = localStorage;
    }
    transform(value, args) {
        const i18nJson = this.i18n.getLangJson(args);
        if (i18nJson) {
            if (value != null) {
                if (value.trim() !== '' && i18nJson.hasOwnProperty(value)) {
                    const text = i18nJson[value];
                    const constants = this.getContansts(text);
                    const temp = this.replaceConstants(text, constants);
                    const result = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(temp));
                    return result;
                }
            }
        }
        return value;
    }
    getContansts(text) {
        const regExp = new RegExp(this.config.tagOpen + '([^' + this.config.tagOpen + this.config.tagClose + '])*' + this.config.tagClose, 'g');
        const constants = text.match(regExp);
        return constants || [];
    }
    replaceConstants(text, constants) {
        if (!isNullOrUndefined(constants)) {
            constants.forEach(constant => {
                let constantKey = constant.replace(this.config.tagOpen, '').replace(this.config.tagClose, '');
                if (!isNullOrUndefined(this.config.constants[constantKey])) {
                    text = text.replace(constant, this.config.constants[constantKey]);
                }
                else {
                    if (constantKey.startsWith('localStorage.')) {
                        const aux = constantKey;
                        constantKey = constantKey.replace('localStorage.', '');
                        if (this.localStorage.getItem(constantKey)) {
                            text = text.replace(this.config.tagOpen + aux + this.config.tagClose, this.localStorage.getItem(constantKey));
                        }
                    }
                }
            });
        }
        return text;
    }
}
/** @nocollapse */ I18nPipe.ɵfac = function I18nPipe_Factory(t) { return new (t || I18nPipe)(ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(I18nService), ɵɵdirectiveInject(AkeelaConfigService), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ I18nPipe.ɵpipe = ɵɵdefinePipe({ name: "i18n", type: I18nPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(I18nPipe, [{
        type: Pipe,
        args: [{
                name: 'i18n'
            }]
    }], function () { return [{ type: DomSanitizer }, { type: I18nService }, { type: AkeelaConfigService }, { type: LocalService }]; }, null); })();

class FormatPipe {
    constructor(_i18n) {
        this._i18n = _i18n;
        /*
          Takes a value and makes it lowercase.
         */
        this.months = [
            '',
            '@i18n-month-january',
            '@i18n-month-february',
            '@i18n-month-march',
            '@i18n-month-april',
            '@i18n-month-may',
            '@i18n-month-june',
            '@i18n-month-july',
            '@i18n-month-august',
            '@i18n-month-september',
            '@i18n-month-october',
            '@i18n-month-november',
            '@i18n-month-december'
        ];
    }
    transform(val) {
        let aux = val.split(',');
        let concat = '';
        if (aux.length === 2) {
            concat = this._i18n.transform(this.months[(aux[0])]).substring(0, 3).toUpperCase() + ',' + aux[1];
            val = concat;
        }
        return val;
    }
}
/** @nocollapse */ FormatPipe.ɵfac = function FormatPipe_Factory(t) { return new (t || FormatPipe)(ɵɵdirectiveInject(I18nPipe)); };
/** @nocollapse */ FormatPipe.ɵpipe = ɵɵdefinePipe({ name: "format", type: FormatPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FormatPipe, [{
        type: Pipe,
        args: [{
                name: 'format'
            }]
    }], function () { return [{ type: I18nPipe }]; }, null); })();

class NumberI18nPipe {
    transform(val, lang) {
        let aux = val.toString();
        if (lang === 'es') {
            aux = this.replace_character(aux, '.', '|');
            aux = this.replace_character(aux, ',', '.');
            aux = this.replace_character(aux, '|', ',');
        }
        return aux;
    }
    replace_character(str, search, value) {
        let aux = '';
        for (let i = 0; i < str.length; i++) {
            aux = aux + this.replace_cases(str[i], search, value);
        }
        return aux;
    }
    replace_cases(character, search, value) {
        switch (character) {
            case search:
                return value;
            default:
                return character;
        }
    }
}
/** @nocollapse */ NumberI18nPipe.ɵfac = function NumberI18nPipe_Factory(t) { return new (t || NumberI18nPipe)(); };
/** @nocollapse */ NumberI18nPipe.ɵpipe = ɵɵdefinePipe({ name: "numberI18n", type: NumberI18nPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NumberI18nPipe, [{
        type: Pipe,
        args: [{
                name: 'numberI18n'
            }]
    }], null, null); })();

const PADDING = "000000";
class NumberTransformPipe {
    constructor() {
        // TODO comes from configuration settings
        this.DECIMAL_SEPARATOR = ",";
        this.THOUSANDS_SEPARATOR = ".";
    }
    transform(value, fractionSize = 2) {
        let [integer, fraction = ""] = (value || "").toString()
            .split(this.DECIMAL_SEPARATOR);
        let result = '';
        fraction = fractionSize >= 0
            ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
            : "";
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
        if (integer != '') {
            result = integer + fraction;
        }
        return result;
    }
    parse(value, fractionSize = 2) {
        let [integer, fraction = ""] = (value || "").split(this.DECIMAL_SEPARATOR);
        let result = '';
        integer = this.replace_character(value, this.THOUSANDS_SEPARATOR, '');
        fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
            ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
            : "";
        if (integer != '') {
            result = integer + fraction;
        }
        return result;
    }
    replace_character(str, search, value) {
        let aux = '';
        for (let i = 0; i < str.length; i++) {
            aux = aux + this.replace_cases(str[i], search, value);
        }
        return aux;
    }
    replace_cases(character, search, value) {
        switch (character) {
            case search:
                return value;
            default:
                return character;
        }
    }
}
/** @nocollapse */ NumberTransformPipe.ɵfac = function NumberTransformPipe_Factory(t) { return new (t || NumberTransformPipe)(); };
/** @nocollapse */ NumberTransformPipe.ɵpipe = ɵɵdefinePipe({ name: "numberTransform", type: NumberTransformPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NumberTransformPipe, [{
        type: Pipe,
        args: [{
                name: 'numberTransform'
            }]
    }], function () { return []; }, null); })();

class I18nModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('AkeelaMultiProductModule is already loaded. Import it in the AppModule only');
        }
    }
    static config(config) {
        return {
            ngModule: I18nModule,
            providers: [
                { provide: AkeelaConfig, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ I18nModule.ɵmod = ɵɵdefineNgModule({ type: I18nModule });
/** @nocollapse */ I18nModule.ɵinj = ɵɵdefineInjector({ factory: function I18nModule_Factory(t) { return new (t || I18nModule)(ɵɵinject(I18nModule, 12)); }, providers: [
        I18nService,
        I18nPipe,
        FormatPipe,
        NumberI18nPipe,
        NumberTransformPipe,
        AkeelaConfigService
    ], imports: [[]] });
__decorate([
    __param(0, Optional()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AkeelaConfig]),
    __metadata("design:returntype", Object)
], I18nModule, "config", null);
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(I18nModule, { declarations: [I18nPipe,
        FormatPipe,
        NumberI18nPipe,
        NumberTransformPipe], exports: [I18nPipe,
        FormatPipe,
        NumberI18nPipe,
        NumberTransformPipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(I18nModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [
                    I18nPipe,
                    FormatPipe,
                    NumberI18nPipe,
                    NumberTransformPipe
                ],
                exports: [
                    I18nPipe,
                    FormatPipe,
                    NumberI18nPipe,
                    NumberTransformPipe
                ],
                providers: [
                    I18nService,
                    I18nPipe,
                    FormatPipe,
                    NumberI18nPipe,
                    NumberTransformPipe,
                    AkeelaConfigService
                ]
            }]
    }], function () { return [{ type: I18nModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

/*
 * Public API Surface of akeela-i18n
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FormatPipe, I18nModule, I18nPipe, I18nService, NumberI18nPipe, NumberTransformPipe };
//# sourceMappingURL=akeela-i18n.js.map
